var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-image-multiple-choice-view"},[(_vm.value.data.cropped)?_c('img',{style:(`border-radius: ${_vm.borderRadius}px;`),attrs:{"width":"100%","height":"100%","src":_vm.value.data.cropped.url,"alt":"multiple choice image"}}):_c('img',{style:(`border-radius: ${_vm.borderRadius}px;`),attrs:{"width":"100%","height":"100%","src":_vm.value.data.image.url,"alt":"multiple choice image"}}),_c('div',{style:(`
        position: absolute;
        width: 100%; 
        height: 100%;
        top: 0; 
        left: 0; 
        background: ${_vm.value.data.overlay || 'rgba(0,0,0,0)'};
        border-radius: ${_vm.borderRadius}px;
      `)})])
}
var staticRenderFns = []

export { render, staticRenderFns }